import React, { createContext, useCallback, useContext, useState } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter } from './ProgramUIHelpers';

const ProgramUIContext = createContext();

export function useProgramUIContext() {
    return useContext(ProgramUIContext);
}

export const ProgramUIConsumer = ProgramUIContext.Consumer;

export function ProgramUIProvider({ programUIEvents, children }) {
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const setQueryParams = useCallback((nextQueryParams) => {
        setQueryParamsBase((prevQueryParams) => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const initProgram = {
        name: '',
        fund_type_code: '',
        branch_uuid: '',
    };

    const value = {
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        initProgram,
        newProgramButtonClick: programUIEvents.newProgramButtonClick,
        openEditProgramPage: programUIEvents.openEditProgramPage,
    };

    return (
        <ProgramUIContext.Provider value={value}>
            {children}
        </ProgramUIContext.Provider>
    );

}
